<template>
  <el-form label-position="left" label-width="270px">
    <!-- <el-form-item label="开启丘成桐少年班六年级">
      <el-checkbox v-model="data.EnableJunior6"></el-checkbox>
    </el-form-item>
    <el-form-item label="报名时间、确认提交时间">
      <div style="display: flex;width: 410px;">
        <el-date-picker v-model="data.SignStartDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  placeholder="选择日期"></el-date-picker>
        <div style="margin: 0 5px;">-</div>
        <el-date-picker v-model="data.SignEndDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  placeholder="选择日期"></el-date-picker>
      </div>
    </el-form-item>
    <el-form-item label="打印报名证/准考证时间、报名信息表时间">
      <div style="display: flex;width: 410px;">
        <el-date-picker v-model="data.PrintStartDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  placeholder="选择日期"></el-date-picker>
        <div style="margin: 0 5px;">-</div>
        <el-date-picker v-model="data.PrintEndDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  placeholder="选择日期"></el-date-picker>
      </div>
    </el-form-item> -->
    <el-form-item label="开启天文地理特长生初三年级">
      <el-checkbox v-model="data.EnableJunior9"></el-checkbox>
    </el-form-item>
    <el-form-item label="报名时间、确认提交时间">
      <div style="display: flex;width: 410px;">
        <el-date-picker v-model="data.Sign9StartDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
        <div style="margin: 0 5px;">-</div>
        <el-date-picker v-model="data.Sign9EndDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
      </div>
    </el-form-item>
    <el-form-item label="打印准考证时间、报名信息表时间">
      <div style="display: flex;width: 410px;">
        <el-date-picker v-model="data.Print9StartDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
        <div style="margin: 0 5px;">-</div>
        <el-date-picker v-model="data.Print9EndDate" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
      </div>
    </el-form-item>
    <el-form-item label="登录后提醒信息">
      <el-input type="textarea" v-model="data.LoginMsg" placeholder="请输入登录后提醒信息"></el-input>
    </el-form-item>
    <el-form-item label="报名置顶信息">
      <el-input type="textarea" rows="5" v-model="data.EnrollTopMsg" placeholder="请输入报名置顶信息"></el-input>
    </el-form-item>
    <div>
      <el-button type="primary" @click="onSave" style="width: 80px;">保 存</el-button>
    </div>
  </el-form>
</template>
<script>
export default {
  data() {
    return {
      api: require("@/api/po/setting").default,
      data: {
        SettingId: null,
        EnableJunior6: false,
        SignStartDate: null,
        SignEndDate: null,
        PrintStartDate: null,
        PrintEndDate: null,

        EnableJunior9: false,
        Sign9StartDate: null,
        Sign9EndDate: null,
        Print9StartDate: null,
        Print9EndDate: null,
        LoginMsg: "",
        EnrollTopMsg: "",
      },
    };
  },
  mounted() {
    this.api.info(1).then((res) => {
      if (res.Code == 0) {
        this.data = res.Data;
      }
    });
  },
  methods: {
    onSave() {
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.save(this.data).then((res) => {
        loading.close();
        if (res.Code == 0) {
          this.$message.success(res.Msg);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>